// Il livello HTTP verso il vecchio backend è stato rimosso.
// L'app ora parla con Supabase (vedi lib/supabase.js e context/AuthContext.jsx).
// Qui resta solo l'helper per i messaggi di errore, usato dalle pagine.

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}